import React from 'react';
import styles from './DemoTakeoutToggle.module.css';

interface DemoTakeoutToggleProps {
  takeoutEnabled: boolean;
  onToggle: (next: boolean) => void;
}

/**
 * 데모 모드 전용 포장 ON/OFF 토글
 * - 실 매장 설정이 아닌, 랜딩페이지에서 진입한 미리보기 환경에서
 *   포장 기능 ON/OFF 두 상태를 전환해볼 수 있도록 제공
 * - 화면 우측 상단에 고정 배치
 */
export function DemoTakeoutToggle({ takeoutEnabled, onToggle }: DemoTakeoutToggleProps) {
  return (
    <div className={styles.wrap} role="group" aria-label="데모 모드 포장 기능 토글" lang="ko">
      <div className={styles.label}>데모 설정</div>
      <div className={styles.switch}>
        <button
          type="button"
          className={`${styles.option} ${!takeoutEnabled ? styles.active : ''}`}
          onClick={() => { if (takeoutEnabled) onToggle(false); }}
          aria-pressed={!takeoutEnabled}
        >
          포장 OFF
        </button>
        <button
          type="button"
          className={`${styles.option} ${takeoutEnabled ? styles.active : ''}`}
          onClick={() => { if (!takeoutEnabled) onToggle(true); }}
          aria-pressed={takeoutEnabled}
        >
          포장 ON
        </button>
      </div>
    </div>
  );
}
